module.exports = __webpack_public_path__ + "static/media/GORM-8493.4b8cffb3.png";